/**
 * Shared app constants (e.g. extension Chrome Web Store + zip fallback).
 * Version matches extension/manifest.json.
 */
export const EXTENSION_VERSION = "1.6.5";
export const APP_VERSION = "0.4.7";
/** Racine du site (sous-domaine dédié ou local) ; pas de préfixe /public/atsmycv. */
export const ASSET_BASE = "";
/** Published listing — primary install link on the site (UTM pour distinguer les clics depuis le site). */
export const EXTENSION_WEB_STORE_URL =
  "https://chromewebstore.google.com/detail/bgdjihmeedoanndgngachlimkjijgepp?utm_source=site&utm_medium=website";
/** Stable URL — always serves the latest packaged extension zip (dev / sideload). */
export const EXTENSION_ZIP_URL = `/atsmycv-extension.zip`;
